<div *ngIf="exportDivOpen" class="table-responsive-sm blocks mb-4">
    <div class="modal-body pt-0">
        <form>
            <div class="row">
                <div class="col-12">
                    <div class="m-3">
                        <label for="imageModelCreate_name" class="form-label label-fw">Filtro Export CSV </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="m-3 mb-0">
                        <label class="form-label label-fw">Data prenotazione</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="m-3 mt-0 mb-0">
                        <label for="imageModelCreate_name" class="form-label label-fw">Preimposta range rapido ad
                            oggi:</label>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row mx-3 text-center">
                        <button (click)="getDateRange('month')" type="button"
                            class="btn btn-outline-warning btn-outline-fw text me-3">Ultimo mese</button>
                        <button (click)="getDateRange('week')" type="button"
                            class="btn btn-outline-warning btn-outline-fw text">Ultima settimana</button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="imageModelCreate_name" class="form-label label-fw">Da</label><br>
                        <div class="form-group">
                            <div class="input-group">
                                <input name="datepicker" class="form-control hidden" ngbDatepicker
                                    #datepicker="ngbDatepicker" [autoClose]="'outside'"
                                    (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t"
                                    [maxDate]="maxDate" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1">
                                <ng-template #t let-date let-focused="focused">
                                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                        [class.faded]="isHovered(date) || isInside(date)"
                                        (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-group">
                                <input #dpFromDate class="form-control" placeholder="yyyy-mm-dd" name="dpFromDate"
                                    [value]="formatter.format(fromDate)"
                                    (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()"
                                        type="button">
                                        <i class="fas fa-calendar-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="imageModelCreate_name" class="form-label label-fw">A</label><br>
                        <div class="form-group ml-2">
                            <div class="input-group">
                                <input #dpToDate class="form-control" placeholder="yyyy-mm-dd" name="dpToDate"
                                    [value]="formatter.format(toDate)"
                                    (input)="toDate = validateInput(toDate, dpToDate.value)">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary calendar" (click)="datepicker.toggle()"
                                        type="button">
                                        <i class="fas fa-calendar-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="imageModelCreate_name" class="form-label label-fw">Filtro città</label><br>
                        <div class="form-group">
                            <div class="input-group">
                                <input [(ngModel)]="storeCity" [ngModelOptions]="{standalone: true}" type="text"
                                    class="form-control" placeholder="Filtro città">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="m-3">
                        <label for="imageModelCreate_name" class="form-label label-fw">Indirizzo Store</label><br>
                        <div class="form-group">
                            <div class="input-group">
                                <input [(ngModel)]="storeAddress" [ngModelOptions]="{standalone: true}" type="text"
                                    class="form-control" placeholder="Indirizzo Store">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <!-- Modal footer -->
        <div class="modal-foot">
            <div class="row my-3 text-center">
                <button type="button" (click)="resetForm()" class="btn btn-outline-fw text me-3">Pulisci</button>
                <button type="button" (click)="save()" class="btn btn-fw text me-3">Invia</button>
            </div>
        </div>
    </div>

</div>

<form [formGroup]="searchFilterForm">
    <!--Searchbar-->
    <div class="row">
        <div class="col-12">
            <div class="d-flex mb-2 px-1">
                <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..."
                    aria-label="Search">
                <button type="submit" (click)="clickSearch()" class="bordersearch"><i
                        class="far fa-search grey mx-2"></i></button>
            </div>
        </div>
    </div>

    <!-- Filters -->
    <div class="row">
        <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 align-items-center">
            
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 p-1" [hidden]="!isSearchReserved">
                <div class="form-check mx-1 form-check-inline">
                    <span class="text fw-normal size15 txt-remove clickable" (click)="toggleSearchReserved()">Cerca per range</span>
                    <br>
                    <label class="form-check-label text fw-normal size16 pt-1" for="flexCheckDefault3">
                        Data prenotazione:
                    </label>
                    <br>
                    <div class="input-group">
                        <input class="form-control form-date-fw mr-1" 
                            placeholder="yyyy-mm-dd" 
                            name="dp" 
                            ngbDatepicker
                            #d="ngbDatepicker" 
                            [dayTemplate]="customDay"
                            (dateSelect)="filterReserved($event)"
                            formControlName="searchFilterField_reserved">
                        <button class="btn form-date-fw calendar" (click)="d.toggle()" type="button">
                            <i class="fas fa-calendar"></i>
                        </button>
                        <ng-template #customDay 
                        let-date="date" 
                        let-currentMonth="currentMonth" 
                        let-selected="selected" 
                        let-disabled="disabled" 
                        let-focused="focused">
                            <span   [ngClass]="customClass(date)"  
                                    [class.focused]="focused"
                                    [class.bg-primary]="selected" 
                                    [class.hidden]="date.month !== currentMonth" 
                                    [class.text-muted]="disabled">
                              {{ date.day }}
                            </span>
                          </ng-template>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-1 inlineflex-md" [hidden]="isSearchReserved">
                <div class="form-check mx-1 form-check-inline">
                    <span class="text fw-normal size15 txt-remove clickable" (click)="toggleSearchReserved()">Cerca per data</span>
                    <br>
                    <label class="form-check-label text fw-normal size16 pt-1" for="flexCheckDefault3">
                        Data prenotazione Range (la data di fine è compresa):
                    </label>
                    <br>
                    <app-date-range [start]="start" [end]="end" (changeRange)="filterChangeRange($event)"></app-date-range>
                </div>
                
            </div>

        </div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 text fw-normal size16 txt-remove">
            <span class="clickable" (click)="clickButtonClearFilter()"> Rimuovi filtri</span>
        </div>
    </div>

    <!-- Riga Export Csv -->
    <div class="row mt-4 my-2">
        <div class="col-12 text fw-normal size15">
            <span *ngIf="userRole === 'ROLE_ADMIN'" (click)="openExportDiv()" class="text fw-normal size15 txt-remove clickable">
                Export Csv
            </span>
        </div>
    </div>
</form>

<!-- Table -->
<div class="w-100" [ngClass]="!isEmpty  ? 'table-responsive-sm blocks': 'not_visible'">
    <table aria-describedby=""  datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table  " style="width: 100%;">
        <thead>
            <tr class="back-white fw-bold">
                <th class="pb-4 border-bottom-0" scope="col">Data di prenotazione</th>
                <th class="pb-4 border-bottom-0" scope="col">Store COMSY</th>
                <th class="pb-4 border-bottom-0" scope="col">Città store</th>
                <th class="pb-4 border-bottom-0" scope="col">Indirizzo</th>
                <th class="pb-4 border-bottom-0" scope="col"></th>
            </tr>
        </thead>
        <tbody [hidden]="isSearching">
            <tr class="table-font" *ngFor="let entity of entityList">
                <td>{{entity.reservationDate}}</td>
                <td>{{entity.storeComsy}}</td>
                <td>{{entity.storeCity}}</td>
                <td>{{entity.storeAddress}}</td>
                <td>
                    <div class="flex">
                        <a class="pr-5 btn btn-lg"><i (click)="clickButtonUpdate(entity.id)"
                                class="far fa-pencil ora clickable"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
        <tfoot [hidden]="!isSearching">
            <tr>
                <td colspan="5">
                    <app-spinner-table [visible]="isSearching"></app-spinner-table>
                </td>
            </tr>
        </tfoot>
    </table>
</div>
<div *ngIf="isEmpty" class="table-responsive-sm blocks no-data w-100">
    <div class="result-message">
        <span class="message-font">La ricerca non ha prodotto risultati!</span>
    </div>
</div>